import { go, html, sortByDesc, strMap } from 'fxjs/es';
import { OMPCoreAtomTmplS } from '../../../Atom/S/Tmpl/module/OMPCoreAtomTmplS.js';

const LANGS = [
  { key: 'kr', label: '한국어' },
  { key: 'en', label: 'English' },
  { key: 'jp', label: '日本語' },
];
export const sideHeaderPc = ({ wish_count = 0, cart_count = 0 } = {}) => {
  const language = TT.lang;
  return html/*html*/ `
    <div class="omp-cell__side-header">
      <div class="omp-cell__side-header-lang-wrapper" data-list-show="false">
        ${_langSection(language)}
        <div class="omp-cell__side-header-button-wrapper">
          <a href="/${language}/wish/list" class="omp-cell__side-header-wish">
            ${OMPCoreAtomTmplS.heartButton({ badge: wish_count })}
          </a>
          <a href="/${language}/cart" class="omp-cell__side-header-cart">
            ${OMPCoreAtomTmplS.cartButton({ badge: cart_count })}
          </a>
          <a href="/${language}/my-page" class="omp-cell__side-header-my-page">
            ${OMPCoreAtomTmplS.avatarButton()}
          </a>
        </div>
      </div>
    </div>
  `;
};

const _langSection = (lang) =>
  html/*html*/ `<div class="omp-cell__side-header-lang-head">
    <div class="omp-cell__side-header-lang-head-left"></div>
    <div class="omp-cell__side-header-lang-head-center">
      <span class="omp-cell__side-header-lang"> ${LANGS.find((lang) => lang.key == TT.lang).label} </span>
    </div>
    <div class="omp-cell__side-header-lang-head-right">
      <i class="omp-cell__side-header-lang-icon"></i>
    </div>
    <ul class="omp-cell__side-header-lang-list">
      ${go(
        LANGS,
        sortByDesc((lang) => {
          return lang.key == TT.lang;
        }),
        strMap((lang) => {
          const is_on = lang.key == TT.lang;
          return html` <li class="omp-cell__side-header-lang-li" data-is_on="${is_on}">
            <a class="omp-change-lang" ${is_on ? '' : ` href="/${lang.key}"`} data-lang="${lang.key}"
              >${lang.label}</a
            >
          </li>`;
        }),
      )}
    </ul>
  </div>`;
